import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setCvTempMethodOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getCardioTempMethodOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCardioTempMethodOptions])
    const { entity } = response
    yield put(setCvTempMethodOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCardioTempMethodOptions() error: ${e}`))
  }
}

export function* getCardioTempMethodOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCardioTempMethodOptions)
}
